import axios from "axios";
import type { AxiosResponse } from "axios";
import type { Note } from "../types/note";
import type { FetchNotesResponse } from "../types/fetchNotesResponse";

const API_URL = "https://notehub-public.goit.study/api/notes";

const token = import.meta.env.VITE_NOTEHUB_TOKEN;

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export interface CreateNoteParams {
  title: string;
  content: string;
  tag: string;
}

export const fetchNotes = async (
  page: number,
  perPage: number,
  search?: string
): Promise<FetchNotesResponse> => {
  const response: AxiosResponse<FetchNotesResponse> = await instance.get("", {
    params: { page, perPage, search },
  });
  return response.data;
};

export const createNote = async (
  note: CreateNoteParams
): Promise<Note> => {
  const response: AxiosResponse<Note> = await instance.post("", note);
  return response.data;
};

export const deleteNote = async (id: string): Promise<Note> => {
  const response: AxiosResponse<Note> = await instance.delete(`/${id}`);
  return response.data;
};

